import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilter = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 20,
	fill: "none",
	viewBox: "0 0 21 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M11.5 13.5C11.5 14.0625 11.7812 14.5312 12.25 14.8125C12.6875 15.0938 13.2812 15.0938 13.75 14.8125C14.1875 14.5312 14.5 14.0625 14.5 13.5C14.5 12.9688 14.1875 12.5 13.75 12.2188C13.2812 11.9375 12.6875 11.9375 12.25 12.2188C11.7812 12.5 11.5 12.9688 11.5 13.5ZM13 11C14.1875 11 15.2188 11.875 15.4375 13H17.5C17.75 13 18 13.25 18 13.5C18 13.7812 17.75 14 17.5 14H15.4375C15.2188 15.1562 14.1875 16 13 16C11.7812 16 10.7812 15.1562 10.5312 14H2.5C2.21875 14 2 13.7812 2 13.5C2 13.25 2.21875 13 2.5 13H10.5312C10.7812 11.875 11.7812 11 13 11ZM8 9C8.53125 9 9 8.71875 9.28125 8.25C9.5625 7.8125 9.5625 7.21875 9.28125 6.75C9 6.3125 8.53125 6 8 6C7.4375 6 6.96875 6.3125 6.6875 6.75C6.40625 7.21875 6.40625 7.8125 6.6875 8.25C6.96875 8.71875 7.4375 9 8 9ZM10.4375 7H17.5C17.75 7 18 7.25 18 7.5C18 7.78125 17.75 8 17.5 8H10.4375C10.2188 9.15625 9.1875 10 8 10C6.78125 10 5.78125 9.15625 5.53125 8H2.5C2.21875 8 2 7.78125 2 7.5C2 7.25 2.21875 7 2.5 7H5.53125C5.78125 5.875 6.78125 5 8 5C9.1875 5 10.2188 5.875 10.4375 7Z"
	})
});
const ForwardRef = forwardRef(SvgFilter);
export default ForwardRef;
